/*global require*/
// Lazy loaders for markdown document bodies. Each .md file becomes its own
// async chunk (webpack require.context lazy mode + asset/source), so post
// bodies are fetched on demand and never bloat the main bundle.
//
// require.context is a webpack-only construct — it's undefined under plain
// Node (scripts/prerender.js, via @babel/register), so calling it throws.
// That's fine: during SSR these loaders are never actually called, because
// contentPreload's cache is already populated (via fs, see
// src/entry-server.jsx) before the components that would call them ever
// render — the try/catch just stops the *module-load-time*
// require.context(...) calls from crashing the whole module in Node.
// (Deliberately not a `typeof require.context === 'function'` check —
// webpack's static analyzer flags bare property access on `require` as an
// ambiguous dependency and warns; a try/catch around literal-argument
// require.context(...) calls doesn't trip it.)
let blogContext, guidesContext, pagesContext;
try {
  blogContext = require.context('../../content/blog', false, /\.md$/, 'lazy');
  guidesContext = require.context('../../content/guides', false, /\.md$/, 'lazy');
  pagesContext = require.context('../../content/pages', false, /\.md$/, 'lazy');
} catch (e) {
  blogContext = guidesContext = pagesContext = null;
}

// gray-matter isn't shipped to the browser — the manifest already carries the
// metadata; we only need to drop the frontmatter block before rendering.
// Exported for src/entry-server.jsx, which reads these files directly via
// fs (not require.context — see the guard above) but needs the exact same
// transform so the preloaded cache matches what the client would compute.
export const stripFrontmatter = (raw) => raw.replace(/^---\r?\n[\s\S]*?\r?\n---\r?\n/, '');

const load = (context, file) => {
  if (!context)
    return Promise.reject(new Error(`content.js: no webpack context available to load "${file}" (running under Node without a preloaded cache entry?)`));
  return context(`./${file}`).then(module => stripFrontmatter(module.default || module));
};

export const loadPostBody = (file) => load(blogContext, file);
export const loadGuideBody = (file) => load(guidesContext, file);
export const loadPageBody = (file) => load(pagesContext, file);
